import logo from "../media/blackLogo.png"
import "../css/navbar.css"
import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import useGenStore from "../store/genstore";
import { signOut,getAuth } from "firebase/auth";
import useFirebaseStore from "../store/firebasestore";
import Swal from "sweetalert2";
function Navbar(){
    const authStatus = useFirebaseStore((s)=>s.authStatus)
    const setCartView= useGenStore((s)=>s.setCartView)
    const setFonView= useGenStore((s)=>s.setFonView)
    const isAdmin = useFirebaseStore((s)=>s.isAdmin)
    const navigate = useNavigate()
    const cartItems = useFirebaseStore((s)=>s.cartItems)

   const logOut =()=>{
          Swal.fire({
                    title:"Are You Sure?",
                    text:"Please confirm you are signing out!",
                    icon:"question",
                    showConfirmButton:true,
                    confirmButtonText:"Log Out",
                    showCancelButton:true,
                    cancelButtonText:"Cancel",
                    cancelButtonColor:"#6a5acd"
                
                }).then((result)=>{
                    if(result.isConfirmed){
                    const auth = getAuth()
                    signOut(auth).then(()=>{
                        navigate("/auth")
                    }).catch(()=>{
                        Swal.fire("Error", "An error occured", "error")
                    })
                    }
                  
                })
    
      
    }
    
    

   useEffect(() => {
  const sendRequest = async () => {
    try {
      const response = await axios.post(
        "https://schoollabelbackend-iwy4.onrender.com/Aloo",
        {}
      );

      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  sendRequest();
}, []);
const contactUs = () => {
  window.location.href = "tel:+254719140419";
};
    return(

        <nav>
            <div className="navPlacer">
                <div className="navLogo">
                    <img src={logo} alt="" />
                </div>
                <div className="navLinks">
                    <div className="navActLinks">
                          <div className="navLink" 
                          onClick={()=> {
                            setFonView(false)
                            navigate("/")
                        }}
                          >
                            <p>Home</p>
                          </div>
                      
                          <div className="navLink" 
                          onClick={()=> navigate("/branding")}
                          >
                            <p>Create Labels</p>
                          </div>
                          <div className="navLink" onClick={()=>contactUs()}>
                            <p>Contact Us</p>
                          </div>
                          {isAdmin &&    <div
                           onClick={()=> navigate("/admin")}
                           className="navLink">
                            <p>Admin Panel</p>
                          </div>}
                    </div>
                    <div className="navLinkBtns">
                        <div className="navAuth">
                            {authStatus == "authenticated" ? (<button onClick={logOut}>Sign Out</button>):(<button onClick={()=>navigate("/auth")}>Sign In</button>)}
                        </div>
                        <div className="navCartIcon" onClick={()=>setCartView(true)}>
                        {cartItems.length >0 &&                             <div className="cartDot"></div>
}
                           <Icon className="faIcon" icon="solar:cart-large-2-bold"/>
                        </div>
                        <div className="navMenuIcon" onClick={()=>setFonView(true)}>
                           <Icon className="faIcon" icon="solar:menu-dots-circle-linear"/>
                        </div>

                    </div>
                </div>

            </div>
        
        
        </nav>
    )
}

export default Navbar;